import { defineStore } from 'pinia';
import { Marketplace } from '../entities/marketplace';
import { marketplaceStepStatusEnum } from '../pages/link-marketplace/helper';

export const useLinkMarketplaceStore = defineStore('linkMarketplace', {
	state: () => ({
		loading: false,
		steps: [],
		linkedMarketplaceId: undefined,
		whatsappQrSession: undefined,
	}),
	getters: {
		marketplace(state) {
			if (!state.steps.length) return {};
			const marketplace = state.steps[0]?.marketplace || {};
			return marketplace;
		},
		currentStep(state) {
			if (state.steps.every((step) => step.status === marketplaceStepStatusEnum.Finished)) {
				return state.steps.length;
			}

			let idx = -1;
			state.steps.forEach((step, index) => {
				if (step.status === marketplaceStepStatusEnum.Finished) {
					idx = index;
				}
			});

			return idx + 2;
		},
		currentStepData(state) {
			if (state.steps.length === 0) return;
			return state.steps[this.currentStep - 1];
		},
	},
	actions: {
		async fetchSteps(linkedMarketplaceId) {
			this.linkedMarketplaceId = linkedMarketplaceId;
			this.loading = true;
			try {
				const { steps, whatsappQrSession } = await Marketplace.getWizard(linkedMarketplaceId);
				this.steps = steps;
				this.whatsappQrSession = whatsappQrSession;
			} finally {
				this.loading = false;
			}
		},
		async refetchSteps() {
			const { steps, whatsappQrSession } = await Marketplace.getWizard(this.linkedMarketplaceId);
			this.steps = steps;
			this.whatsappQrSession = whatsappQrSession;
		},
	},
});
